import { COLUMN_NAME, COLUMN_SITE } from "../../constants/column-types";
import { TableColumn } from "../table/TableColumn";

const TourRouteColumns: TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        active: true,
        sortByName: "tourName",
        sortDirection: "asc",
        translationKey: "name",
        isDefault: true,
        columnId: COLUMN_NAME,
    },
    {
        heading: "Site",
        accessor: "site",
        isNumeric: false,
        id: 1,
        active: true,
        sortByName: "area.site.siteName",
        sortDirection: "asc",
        searchOnName: "area.site.id",
        lookupName: "area.site.siteName",
        translationKey: "site",
        columnId: COLUMN_SITE,
    }
];

export default TourRouteColumns
